export default {"LABEL":"FA Regular 通用图标","DESC":"来自 FontAwesome 的图标库.","COMPONENTS":{"__markdown":true}}